import some from "lodash/some";
import { Select } from "PFComponents/select";
import { getProfileName } from "PFCore/helpers/profile";
import { fetchProfilesOptions } from "PFCore/services/profile";
import { BasicProfile } from "PFTypes";
import { Id } from "PFTypes/id";
import { Option } from "PFTypes/options";
import { useTranslation } from "react-i18next";

import css from "./vacancy.module.scss";

type CandidateSelectProps = {
  candidateId: number;
  selectedProfileIds: Id[];
  onCandidateChange: (value: number | null) => void;
};

export const CandidateSelect = ({
  candidateId,
  selectedProfileIds,
  onCandidateChange
}: CandidateSelectProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.vacancies" });

  return (
    <Select
      className={css.columnItem}
      label={t("workforceMember")}
      onChange={(profile: Option<BasicProfile>) => onCandidateChange(Number(profile.id))}
      value={candidateId ? Number(candidateId) : undefined}
      fetchOptions={async ({ searchTerm, ids }) => {
        const result = await fetchProfilesOptions({
          term: searchTerm,
          value: ids
        });
        return {
          entries: result.entries.map((item) => ({
            id: item.id,
            displayElement: getProfileName(item),
            value: getProfileName(item),
            original: item,
            disabled: some(selectedProfileIds, (id) => id === String(item.id))
          })),
          meta: result.meta
        };
      }}
    />
  );
};
